<template>
  <div class="date-time-header">
    <h1>{{ currentDateTime }}</h1>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const currentDateTime = ref("");

const formatDateTime = () => {
  const now = new Date();
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
  }).format(now);
};

onMounted(() => {
  currentDateTime.value = formatDateTime(); // Initialize
  setInterval(() => {
    currentDateTime.value = formatDateTime(); // Update every second
  }, 1000);
});
</script>

<style scoped>
.date-time-header {
  font-size: 1.5em;
  margin-bottom: 1em;
  font-weight: bold;
}
</style>
